import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { createTheme } from '@mui/material/styles';

const palette = {
  common: {
    black: '#000000',
    white: '#ffffff',
    transparent: 'rgba(0, 0, 0, 0)',
  },
  layout: {
    main: {
      light: '#f8f8f8',
    },
  },
};

const baseTheme = {
  palette,
  direction: 'ltr',
  layout: {
    sidebar: {
      minWidth: 64,
      maxWidth: 200,
    },
    header: {
      height: 64,
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        size: 'medium',
        color: 'primary',
        variant: 'contained',
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 4,
      },
    },
    MuiTypography: {
      defaultProps: {
        variant: 'body1',
        color: 'initial',
      },
    },
  },
};

const lightTheme = createTheme({
  ...baseTheme,
});

const darkTheme = createTheme({
  ...baseTheme,
});

export { darkTheme, lightTheme };
